export default "__VITE_ASSET__DZuEDR2k__"